import { render, staticRenderFns } from "./ServiceRequests.vue?vue&type=template&id=be3e8216"
import script from "./ServiceRequests.vue?vue&type=script&lang=js"
export * from "./ServiceRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports